<template>
    <div class="header-cart-container" :class="{'empty-cart' : emptyCart, 'is-firefox' : isFirefox}">
        <div v-if="loadingCart" style="width:100%; height: 200px;">
            <MuffinLoader />
        </div>
        
        <div v-if="showEmptyCart" class="mini-cart-header">
            <p class="mini-cart-title"> {{ kStrings.kCART_EMPTY }} </p>
            <p class="mini-cart-subtitle"> {{ kStrings.kSTART_ADDING_ITEMS }} </p>
        </div>
        <div v-else-if="showHeader" class="mini-cart-header-wrapper">
            <div class="mini-cart-header filter">
                <p class="mini-cart-title"> {{ kStrings.kGLOB_SHOPPING_CART }} </p>
                <p v-if="cartData" class="mini-cart-subtitle"> {{ cartData.productsString }} </p>
            </div>
        </div>

        <div v-if="hasGlobalError" class="cart-product-list">
            <div class="alerts-container" :class="{empty: !cartData}">
                <p class="cart-alert">
                    <i class="prz-info"/><span v-html="errorMsg" />
                </p>
            </div>
        </div>

        <div v-if="showProductsList" class="cart-product-list">
            <div v-if="cartData && cartData.alerts.length" class="alerts-container">
                <p v-for="(alert, index) in cartData.alerts" class="cart-alert">
                    <i class="prz-info"/><span v-html="alert"/>
                </p>
            </div>
            <div v-for="(cartItem, index) in cartData.products" class="cart-item-group">
                <div class="cart-item" :class="{'cant-buy' : !cartItem.canBuy }"
                     :key="'cart-item-' + cartItem.cartItemId">
                    <MuffinLoader v-if="cartItem.updating"/>
                    <div v-if="cartItem.label" class="offer-label" v-html="cartItem.label"/>
                    <img :src="cartItem.img" class="item-img" :alt="cartItem.name" @click="goto(cartItem.url)"/>
                    <div class="mx-0 item-info-container">
                        <div class="action-labels">
                            <span v-if="cartItem.immersivePoints" class="points-label" :class="{'positive' : !cartItem.isGift}">
                                {{ !cartItem.isGift ? '+' : '' }}
                                {{ cartItem.immersivePoints }}
                                <i class="prz-prozis-points"/>
                            </span>
                            <i v-if="!cartItem.isOpportunity" class="remove-item prz-close" @click="removeCartItem(cartItem.cartItemId, index)"/>
                        </div>
                        <div class="prod-labels">
                            <div v-if="!cartItem.canBuy" class="item-sticker stock">
                                <i class="prz-info"/> {{ kStrings.kPROD_STOCK_OUT }}
                            </div>
                            <a :href="cartItem.url" class="item-label name-label clamp" data-mub-skip="y">
                                {{ cartItem.name }}
                            </a>
                            <p v-if="cartItem.variantLabel" class="item-label light variant-label clamp clamp-1">
                                {{ cartItem.variantLabel }}
                            </p>
                            <!-- <p v-if="cartItem.messages && cartItem.messages.length" v-for="(msg, index) in cartItem.messages" class="item-label item-msg" v-html="msg.text"/> -->
                        </div>
                        <div class="bottom-info">
                            <div v-if="cartItem.canBuy" class="simple-quantity-wrapper">
                                <div class="item-counter">
                                    <i class="prz-minus" @click.stop="qtyHandler(index, false)"/>
                                    <span class="item-qty"> {{ cartItem.qty.toString().padStart(2, "0") }} </span>
                                    <i class="prz-plus" @click.stop="qtyHandler(index)"/>
                                </div>
                            </div>
                            <div v-if="cartItem.isFrozen" class="item-sticker frozen"
                                 :class="{'no-text' : cartItem.canBuy}">
                                <i class="prz-frozen"/>
                                {{ !cartItem.canBuy ? kStrings.kPRODUTO_CONGELADO : '' }}
                            </div>
                            <div class="price-labels">
                                <span v-if="cartItem.priceCrossed" class="item-label crossed"> {{
                                        cartItem.priceCrossed
                                    }}
                                </span>
                                <span v-if="!cartItem.immersivePoints && cartItem.isGift" class="item-label item-points"><i class="prz-prozis-points"/> {{ cartItem.points }} </span>
                                <span v-else class="item-label" :class="{'is-free' : cartItem.isGift}"> {{ cartItem.price }} </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="cartItem.children && cartItem.children.length" v-for="(childItem, idx) in cartItem.children"
                     class="cart-item child-item"
                     :class="{'cant-buy' : !childItem.canBuy }"
                     :key="'cart-item-' + childItem.cartItemId"
                >
                    <div v-if="childItem.label" class="offer-label" v-html="childItem.label"/>
                    <img :src="childItem.img" class="item-img" :alt="childItem.name" @click="goto(childItem.url)"/>
                    <div class="mx-0 item-info-container">
                        <div class="prod-labels">
                            <div v-if="!childItem.canBuy" class="item-sticker stock">
                                <i class="prz-info"/>
                                {{ kStrings.kPROD_STOCK_OUT }}
                            </div>
                            <a :href="childItem.url" class="item-label name-label clamp" data-mub-skip="y">
                                {{ childItem.name }} </a>
                            <p v-if="childItem.variantLabel" class="item-label light variant-label clamp clamp-1">
                                {{ childItem.variantLabel }}
                            </p>
                            <!-- <p v-if="childItem.messages && childItem.messages.length" v-for="(msg, index) in childItem.messages" class="item-label item-msg" v-html="msg.text"/> -->
                        </div>
                        <div class="bottom-info">
                            <div class="simple-quantity-wrapper">
                                <p> {{ kStrings.kQUANTITY + ': ' + childItem.qty }} </p>
                            </div>
                            <div v-if="childItem.isFrozen" class="item-sticker frozen">
                                <i class="prz-frozen"/>
                                {{ !childItem.canBuy ? kStrings.kPRODUTO_CONGELADO : '' }}
                            </div>
                            <div class="price-labels">
<!--                                <span v-if="childItem.isGift" class="item-label item-points">
                                    <i class="prz-prozis-points"/> {{ childItem.points }} </span>
                                <span v-else class="item-label"> {{ childItem.price }} </span>-->
                                <span class="item-label" :class="{'is-free' : childItem.isGift}"> {{ childItem.price }} </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="cartData && cartData.coupons.length" v-for="(coupon, index) in cartData.coupons" class="cart-item-group">
                <div class="cart-item coupon-item"
                     :class="{'has-image' : coupon.image}"
                     :key="'coupon-item-' + coupon.cart_lin_id">
                    <div v-if="coupon.label" class="offer-label" v-html="coupon.label"/>
                    <img v-if="coupon.image" :src="coupon.image" class="item-img" :alt="coupon.name" @click="coupon.url ? goto(coupon.url) : ''"/>
                    <div class="mx-0 item-info-container">
                        <div class="prod-labels">
                            <p class="item-label name-label clamp" data-mub-skip="y">
                                <i v-if="!coupon.image" class="prz-discount"/> {{ coupon.name }}
                            </p>
                        </div>
                        <div class="bottom-info">
                            <div class="simple-quantity-wrapper">
                                <p> {{ kStrings.kQUANTITY + ': ' + coupon.quantity }} </p>
                            </div>
                            <div class="price-labels">
                                <span v-show="coupon.price" class="item-label"> {{ formatPrice(coupon.price) }} </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="showProductsList" class="mini-cart-footer filter">
            <p v-if="cartData" class="total-info"> {{ kStrings.kGLOB_SUBTOTAL + ':' }}
                <span class="info"> {{ cartData.total }} </span>
            </p>
            <button class="mini-cart-button" @click="goto(cartData.checkoutUrl)">
                {{ kStrings.kPROCEED_TO_CHECKOUT }}
            </button>
        </div>
    </div>
</template>

<script>

import request from '@/Utilities/httpRequest';
import utilities from '@/Utilities/common';
import apiCart from '@/api/cart';
import browser from '@/Utilities/browser';

import MuffinLoader from '@/components/Muffin/Loader';

export default {
    name: 'MiniCart',
    components: {
        MuffinLoader
    },
    props: {
        errorMsg: {
            type: String,
            default: null
        },
        url: {
            type: String,
            default: ''
        },
        emptyCart: {
            type: Boolean,
            default: false
        }
    },
    created() {
    },
    data() {
        return {
            loadingCart: true,
            cartData: null,
            qtyTimer: null,
            i18n: null, // use prop because "remove item" and "change quantity" does not return it
            hasGlobalError: false,
            isGoToCheckoutClicked: false,
        }
    },
    watch: {},
    methods: {
        async loadMiniCart(refresh) {
            this.hasGlobalError = false;
            this.loadingCart = true;
            //console.log('minicart: refresh value', refresh)
            const result = await request.get(this.url, {refresh: refresh === true ? '1' : null}, false);
            if(result && result.data && result.data.products){
                this.cartData = result.data;
                this.i18n = result.data.i18n; // store translations
                this.$emit('update-cart', {itemCount: this.cartData.cartQty, value: this.cartData.total, pointsInfo: this.cartData.pointsInfo});
            }
            else if(result && result.data && result.data.error === 'NETWORK'){
                // user navigated away (request aborted)
            }
            else{
                this.hasGlobalError = true;
            }
            this.loadingCart = false;
        },
        goto(url = '') {
            if(!this.isGoToCheckoutClicked){
                this.isGoToCheckoutClicked = true;
                utilities.goToUrl(url);
            }
        },
        qtyHandler(index = -1, add = true) {
            if (index >= 0) {
                const prodQty = this.cartData.products[index].qty;
                const maxQty = this.cartData.products[index].maxQty ?? 20;
                if ((!add && prodQty > 1) || (add && prodQty < maxQty)) {
                    this.cartData.products[index].qty = add ? prodQty + 1 : prodQty - 1;
                    if (this.qtyTimer) {
                        clearTimeout(this.qtyTimer);
                    }
                    this.qtyTimer = setTimeout(() => {
                        this.updateCartItemQty(this.cartData.products[index].cartItemId, this.cartData.products[index].qty, index);
                    }, 400);
                }
            }
        },
        async updateCartItemQty(itemId, qty = 0, itemIndex = 0) { // merge these 2 functions ?
            this.hasGlobalError = false;
            if (qty) {
                this.cartData.products[itemIndex].updating = true;
                const {data} = await apiCart.updateItem(itemId, qty, false, true, true);
                if(data.products){
                    this.cartData = data;
                    this.$emit('update-cart', {itemCount: this.cartData.cartQty, value: this.cartData.total, pointsInfo: this.cartData.pointsInfo});
                }
                else{
                    this.hasGlobalError = true;
                }

                if (this.cartData.products[itemIndex]) {
                    this.cartData.products[itemIndex].updating = false;
                }
            }
        },

        async removeCartItem(itemId, itemIndex = 0) { // TODO  add bugsnag
            this.hasGlobalError = false;
            this.cartData.products[itemIndex].updating = true;
            const {data} = await apiCart.removeItem(itemId, false, true, true);
            if(data.products){
                this.cartData = data;
                this.$emit('update-cart', {itemCount: this.cartData.cartQty, value: this.cartData.total, pointsInfo: this.cartData.pointsInfo});
            }
            else{
                this.hasGlobalError = this.true;
            }

            if (this.cartData.products[itemIndex]) {
                this.cartData.products[itemIndex].updating = false;
            }
        },
        closeCart() {
            this.$emit('close-cart');
        },
        formatPrice(price) {
            return App.js.formatPrice(price);
        }
    },
    computed: {
        kStrings() {
            return this.i18n ?? null;
        },
        showProductsList() {
            if (!this.cartData || !this.cartData.products || !this.cartData.products.length) {
                return false;
            }

            return !this.emptyCart;
        },
        showEmptyCart() {
            if(this.loadingCart){
                return false;
            }

            if (this.emptyCart && !this.cartData && !this.hasGlobalError) {
                return true;
            }

            return this.cartData && this.cartData.cartQty == 0;
        },
        showHeader(){
            return this.cartData ? true : false;
        },
        isFirefox() {
            return browser.getBrowser() == 'firefox';
        }
    },
    mounted() {
        /*if (this.url && !this.emptyCart) {
            this.loadMiniCart();
        }*/
    }
}
</script>

<style lang="scss">
@import "miniCart";
</style>
